// Flagged-findings card. Extracted verbatim from AuditPreview.jsx (W2b).
// Same enumeration markup, same key derivation, same test-id pattern.
export default function PreviewWeaknesses({ detectedWeaknesses }) {
  return (
    <div className="sf-card" style={{ marginBottom: 28 }} data-testid="preview-weaknesses-card">
      <div className="sf-eyebrow" style={{ marginBottom: 6 }}>What the diagnostic flagged</div>
      <p className="sf-muted-text" style={{ fontSize: 13, lineHeight: 1.55, marginBottom: 14, maxWidth: 660 }}>
        Each finding ties back to an answer you gave. The paid report turns each one into a fix with a recovery estimate and a 30/60/90-day timeline.
      </p>
      <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "grid", gap: 12 }}>
        {detectedWeaknesses.map((w, idx) => (
          <li
            key={`weak-${w.slice(0, 60).replace(/\s+/g, "-")}`}
            data-testid={`preview-weakness-${idx}`}
            style={{ display: "flex", gap: 12, alignItems: "flex-start" }}
          >
            <span className="sf-mono sf-gold" style={{ minWidth: 24, fontSize: 13, paddingTop: 4 }}>
              {String(idx + 1).padStart(2, "0")}
            </span>
            <span style={{ color: "var(--sf-offwhite)", lineHeight: 1.55 }}>{w}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
